import styled, { css } from 'styled-components';

const Flex = styled.div.withConfig({
  shouldForwardProp: (prop) => !['direction', 'justify', 'align', 'gap', 'flex1'].includes(prop),
})<{
  direction?: 'row' | 'column';
  justify?:
    | 'flex-start'
    | 'center'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  align?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
  gap?: string;
  flex1?: boolean;
}>(
  ({ direction, justify, align, gap, flex1 }) => css`
    display: flex;
    flex-direction: ${direction ?? 'row'};
    justify-content: ${justify ?? 'flex-start'};
    align-items: ${align ?? 'flex-start'};
    gap: ${gap ?? '0px'};
    flex: ${flex1 ? '1' : '0 1 auto'};
  `,
);

export default Flex;
